module.exports = __webpack_public_path__ + "media/images/city_img/o_2-b041bd773a5055995c33e69f9dbdfe15.jpg";